
import { connect } from "react-redux";
import { InboxDashboard } from "./InboxDashboard";
import {emailLoadInbox, markMessageRead, sendMessage} from "../actions";

const mapDispatchToProps = dispatch => {
  return {
    emailLoadInbox: () => dispatch(emailLoadInbox()),
    markMessageRead: message_id => dispatch(markMessageRead(message_id)),
    sendMessage: (from, to, subject, text) => dispatch(sendMessage(from, to, subject, text)),
  };
};

const mapStateToProps = state => {
  return {
    client: state.client,
    inbox: state.inbox,
    user: state.user,
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(InboxDashboard);
